import { observer } from 'mobx-react';

import type { FormProps } from '../EditEntryDataForm';

import { translate } from '@chaika/i18n/helper';
import { useEntryDataForm } from '../hooks/forms/useEntryDataForm';
import { Border } from '@components/Border';
import { Checkbox } from '@components/Checkbox';
import { TaskDevicePopup } from 'chaika-test-attributes';
import { DeviceSelect } from '@components/ModelSelect/DeviceSelect';

interface Props extends FormProps {}

export const EntryDataForm = observer(({ entry }: Props): React.ReactElement<any> => {
    const { inDoor, deviceId, onInDoorChange, onDeviceChange } = useEntryDataForm({ entry });

    return (
        <>
            <Border />
            <Checkbox
                label={translate('inDoor')}
                isChecked={inDoor}
                onChange={onInDoorChange}
            />
            <Border />
            <DeviceSelect
                dataTest={TaskDevicePopup.PopupSelectDevice}
                deviceId={deviceId}
                onChange={onDeviceChange}
            />
        </>
    );
});
